// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.A11yMenu_a11yMenu__snSPh {
  grid-area: a11yMenu;
  background: var(--background-color-3);
  position: relative;
}
.A11yMenu_a11yMenu__snSPh .A11yMenu_a11yButton__W\\+rqm {
  gap: 0.25rem;
}
.A11yMenu_a11yMenu__snSPh .A11yMenu_a11yButton__W\\+rqm svg:not(.A11yMenu_menuIndicator__zYhvk) {
  transform: scale(1.75);
}
.A11yMenu_a11yMenu__snSPh .A11yMenu_a11yButton__W\\+rqm .A11yMenu_menuIndicator__zYhvk {
  transition: all 0.3s ease;
  margin-left: 0.5em;
}
.A11yMenu_a11yMenu__snSPh .A11yMenu_a11yButton__W\\+rqm[aria-expanded=true] .A11yMenu_menuIndicator__zYhvk {
  transform: rotate(180deg);
}

.A11yMenu_a11yModal__GI7fc {
  border-radius: 0 20px 20px 20px;
  background: var(--background-color-3);
  animation: A11yMenu_show__48IJs 0.6s ease forwards;
  z-index: var(--menuIndex);
  overflow: hidden;
}
.A11yMenu_a11yModal__GI7fc .A11yMenu_checkbox__cuKjg {
  margin: 1rem;
  color: var(--background-color-1);
  display: flex;
  gap: 1em;
  align-items: center;
}
.A11yMenu_a11yModal__GI7fc .A11yMenu_checkbox__cuKjg label p {
  white-space: nowrap;
}

.nightMode .A11yMenu_a11yMenu__snSPh button:hover svg:not(.A11yMenu_menuIndicator__zYhvk) {
  color: var(--foreground-color-1);
}

@keyframes A11yMenu_show__48IJs {
  from {
    max-width: 0;
    max-height: 0;
  }
  to {
    max-width: 100vw;
    max-height: 100vh;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/Template/components/Menu/A11yMenu.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,qCAAA;EACA,kBAAA;AACF;AAAE;EACE,YAAA;AAEJ;AADI;EACE,sBAAA;AAGN;AADI;EACE,yBAAA;EACA,kBAAA;AAGN;AAAM;EACE,yBAAA;AAER;;AAIA;EACE,+BAAA;EACA,qCAAA;EACA,kDAAA;EACA,yBAAA;EACA,gBAAA;AADF;AAEE;EACE,YAAA;EACA,gCAAA;EACA,aAAA;EACA,QAAA;EACA,mBAAA;AAAJ;AAEI;EACE,mBAAA;AAAN;;AAQM;EACE,gCAAA;AALR;;AAWA;EACE;IACE,YAAA;IACA,aAAA;EARF;EAUA;IACE,gBAAA;IACA,iBAAA;EARF;AACF","sourcesContent":[".a11yMenu {\n  grid-area: a11yMenu;\n  background: var(--background-color-3);\n  position: relative;\n  .a11yButton {\n    gap: 0.25rem;\n    svg:not(.menuIndicator) {\n      transform: scale(1.75);\n    }\n    .menuIndicator {\n      transition: all 0.3s ease;\n      margin-left: 0.5em;\n    }\n    &[aria-expanded=\"true\"] {\n      .menuIndicator {\n        transform: rotate(180deg);\n      }\n    }\n  }\n}\n\n.a11yModal {\n  border-radius: 0 20px 20px 20px;\n  background: var(--background-color-3);\n  animation: show 0.6s ease forwards;\n  z-index: var(--menuIndex);\n  overflow: hidden;\n  .checkbox {\n    margin: 1rem;\n    color: var(--background-color-1);\n    display: flex;\n    gap: 1em;\n    align-items: center;\n\n    label p {\n      white-space: nowrap;\n    }\n  }\n}\n\n:global(.nightMode) {\n  .a11yMenu {\n    button:hover {\n      svg:not(.menuIndicator) {\n        color: var(--foreground-color-1);\n      }\n    }\n  }\n}\n\n@keyframes show {\n  from {\n    max-width: 0;\n    max-height: 0;\n  }\n  to {\n    max-width: 100vw;\n    max-height: 100vh;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"a11yMenu": `A11yMenu_a11yMenu__snSPh`,
	"a11yButton": `A11yMenu_a11yButton__W+rqm`,
	"menuIndicator": `A11yMenu_menuIndicator__zYhvk`,
	"a11yModal": `A11yMenu_a11yModal__GI7fc`,
	"show": `A11yMenu_show__48IJs`,
	"checkbox": `A11yMenu_checkbox__cuKjg`
};
export default ___CSS_LOADER_EXPORT___;
